"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const charMap = {
    '>': '&gt;',
    '<': '&lt;',
    "'": '&apos;',
    '"': '&quot;',
    '&': '&amp;',
};
exports.default = (str = '') => str.replace(/([&"<>'])/g, (s, item) => charMap[item]);
//# sourceMappingURL=xml-escape.js.map